import styled, {css} from 'styled-components'

export const StyledConversationEntitySelector = styled.div(
    ({theme: {palette, spacing}}) => css`
        padding: ${spacing * 2}px;
        border-top: 1px solid ${palette.neutral[200]};
        width: 100%;
    `
)
